document.addEventListener('DOMContentLoaded', function () {
  // Get the product "is new" status from the predefined variable
  const isNew = isProductNew === 'true'; // `isProductNew` comes from the theme script
  
  console.log("isProductNew:", isProductNew);

  // Initialize the "Leer más" modal
  const uniquePopupButton = document.getElementById('uniquePopupButton');
  const uniqueCloseModal = document.getElementById('uniqueCloseModal');
  const uniqueModal = document.getElementById('uniqueModal');
  const uniqueModalContent = document.getElementById('uniqueModalContent');

  if (uniquePopupButton && uniqueModal && uniqueCloseModal) {
    uniquePopupButton.addEventListener('click', function () {
      uniqueModal.style.display = 'block';

      // Use the `metafieldHTML` variable to populate modal content
      if (metafieldHTML) {
        uniqueModalContent.innerHTML = metafieldHTML;
      } else {
        uniqueModalContent.innerHTML = "<p>Content not available</p>";
      }
    });

    uniqueCloseModal.addEventListener('click', function () {
      uniqueModal.style.display = 'none';
    });

    window.addEventListener('click', function (event) {
      if (event.target === uniqueModal) {
        uniqueModal.style.display = 'none';
      }
    });
  } else {
    console.warn("Elements for 'Leer más' modal are missing.");
  }
  
  // Select the Semi-Nueva section container
  const semiNuevaSection = document.getElementById('semiNuevaSection');

  // Check the "is new" status and hide the section if necessary
  if (semiNuevaSection && isProductNew === 'true') {
    semiNuevaSection.style.display = 'none';
    console.log("'Certificada Semi-Nueva' section is hidden because the product is marked as new.");
  } else if (semiNuevaSection) {
    console.log("'Certificada Semi-Nueva' section is displayed.");
  } else {
    console.warn("'Certificada Semi-Nueva' section not found.");
  }
  

  // Payment Plans Modal
  const paymentModalButton = document.getElementById('paymentModalButton');
  const paymentCloseModal = document.getElementById('paymentCloseModal');
  const paymentPlansModal = document.getElementById('paymentPlansModal');

  if (paymentModalButton && paymentCloseModal && paymentPlansModal) {
    paymentModalButton.addEventListener('click', function () {
      paymentPlansModal.style.display = 'block';
    });

    paymentCloseModal.addEventListener('click', function () {
      paymentPlansModal.style.display = 'none';
    });

    window.addEventListener('click', function (event) {
      if (event.target === paymentPlansModal) {
        paymentPlansModal.style.display = 'none';
      }
    });
  }

  // Update Modal Content Function
  function updateModalContent() {
    const downPayment = productPrice * 0.3;
    const remainingAmount = productPrice * 0.7;
    const calculateMonthlyPayment = (months) =>
      remainingAmount * ((0.35 / 12) + (1 / months));

    const monthlyPayment4 = calculateMonthlyPayment(4).toFixed(0);
    const monthlyPayment8 = calculateMonthlyPayment(8).toFixed(0);
    const monthlyPayment12 = calculateMonthlyPayment(12).toFixed(0);

    const downPaymentText = document.getElementById('downPaymentText');
    const monthlyPaymentText = document.getElementById('monthlyPaymentText');

    if (downPaymentText && monthlyPaymentText) {
      downPaymentText.innerText = `Pago inicial: $${downPayment.toLocaleString()}`;
      monthlyPaymentText.innerText = `Desde $${monthlyPayment12.toLocaleString()} al mes sin tarjeta de crédito.`;
    }
  }

  // Function to calculate and display the selling price
  function calculateSellingPrice(price) {
    const sellingPriceElement = document.getElementById('sellingPrice');
    if (!isNaN(price) && price > 0) {
      const sellingPrice = price / 0.6; // Calculate selling price
      if (sellingPriceElement) {
        sellingPriceElement.textContent = `$${sellingPrice.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      }
    } else if (sellingPriceElement) {
      sellingPriceElement.textContent = ` `; // Default value
    }
  }

  // Call the functions
  calculateSellingPrice(productPrice);
  updateModalContent();

  // Update modal content on URL change
  window.addEventListener('popstate', function () {
    setTimeout(updateModalContent, 500);
  });
});
